<template>
  <div class="lestrade">
    <div class="error" v-if="errorMessage">{{errorMessage}}</div>
    <h2>L'inspecteur est ravi de vous voir déjà de retour dans son bureau...</h2>
    <div class="center">
      <input type="text" maxlength="5" placeholder="_____" v-model="answer" />
    </div>
    <div class="center">
      <div class="button" @click="checkAnswer()">Révéler le nom du coupable</div>
    </div>
    <h3
      style="color: #860C24"
    >Attention, vous n'avez pas le droit à l'erreur. Il ne s'agirait pas de vous ridiculiser en discréditant Lestrade à Scotland Yard !</h3>
  </div>
</template>
<script>
export default {
  name: "Lestrade",
  props: {
    errorTime: Number
  },
  data() {
    return {
      answer: null,
      errorMessage: null
    };
  },
  methods: {
    checkAnswer() {
      this.errorMessage = null;
      if (this.errorTime) {
        const diff = Math.abs(new Date() - this.errorTime);
        const duration = Math.ceil(diff / 1000 / 60);
        if(duration <= 3) {
          this.errorMessage = `Lestrade vous en veut encore de lui avoir donner le mauvais coupable. Prenez le temps de la  réflexion, revenez dans ${4 - duration} minutes.`;
          return
        }
      }
      if (!this.answer || this.answer.length < 5) {
        this.errorMessage = "Le nom du coupable doit comporter 5 lettres.";
        return;
      }
      if (this.answer.toUpperCase() === "FEWIN") {
        console.log("you win");
        this.$emit("success", true);
      } else {
        console.log("you lose");
        const answer = this.answer.toUpperCase().split('');
        const message = [];
        if(answer[0]!= 'F') message.push('la première');
        if(answer[1]!= 'E') message.push('la seconde');
        if(answer[2]!= 'W') message.push('la troisième');
        if(answer[3]!= 'I') message.push('la quatrième');
        if(answer[4]!= 'N') message.push('la cinquième');
        let output = ''
        if(message.length === 1) {
          output = `${message[0]} lettre ne permet aucune correspondance dans le fichier de la police.`;
          }
        if(message.length > 1) {
          output = `${message.slice(0, -1).join(', ')} et ${message.slice(-1)} lettres ne permettent aucune correspondance dans le fichier de la police.`;
          }
        this.errorMessage = output.charAt(0).toUpperCase() + output.slice(1);
        this.$emit("error", Date.now());
      }
    }
  }
};
</script>

<style scoped>
.lestrade {
  padding: 10% 10%;
  font-size: 20px;
  overflow: scroll;
  text-align: justify;
  height: 80%;
}
.message {
  font-family: "Permanent Marker", cursive;
  font-size: 30px;
  letter-spacing: 4px;
  background: rgb(210, 210, 210);
  margin: 5% 20%;
  padding: 20px;
}
.center {
  display: flex;
  justify-content: center;
  margin: 10% 5%;
}
.button {
  font-size: 2vw;
  color: rgb(210, 210, 210);
  background: rgb(80, 80, 80);
  padding: 10px 20px;
  border-radius: 15px;
  text-align: center;
}
.button:hover {
  cursor: pointer;
  box-shadow: 0 0 30px 10px rgb(210, 210, 210);
}
.error {
  background: lightpink;
  padding: 3%;
  border-radius: 15px;
}
input {
  font-size: 40px;
  max-width: 180px;
  letter-spacing: 4px;
  font-family: "Playfair Display", serif;
  font-weight: bold;
  text-align: center;
  background: rgb(210, 210, 210);
  line-height: 15px;
  color: rgb(80, 80, 80);
  border: none;
  text-transform: uppercase;
  border-bottom: 4px solid rgb(80, 80, 80);
}
input:focus {
  outline: none;
}
</style>